import { useContext } from "react";
import PlanPermissionsContext from "../../context/PlanPermissions/PlanPermissionsContext";

const usePlanPermissions = () => {
  const context = useContext(PlanPermissionsContext);

  if (!context) {
    throw new Error('usePlanPermissions must be used within a PlanPermissionsProvider');
  }

  return context;
};

export default usePlanPermissions;
